export default "__VITE_ASSET__7171eee7__"